module.exports = __webpack_public_path__ + "img/1537979279.3070add8.jpg";